<div
  class="page-container rb-chatbot container w-100"
  [ngClass]="{ 'embedded pt-0': embedded, 'pt-2': !embedded }"
>
  @if (!embedded) {
    <h1 class="header col-12 mt-3 mb-3">
      RightBRIDGE Chatbot

      <button type="button" matButton color="warn" (click)="resetChat()">
        <mat-icon>reset_tv</mat-icon> Restart Chat
      </button>
    </h1>
  }

  <div class="row chatbot-container">
    <div class="col-md-7 col-12 card-container">
      <div class="info-card w-100 p-0" [ngClass]="{ 'mb-4': !embedded }">
        <div class="card-header">
          @if (embedded) {
            <span>Ask About Products</span>
            <span>
              <button
                type="button"
                matButton
                color="warn"
                (click)="resetChat()"
              >
                <mat-icon>reset_tv</mat-icon> Restart Chat
              </button>
              <button type="button" mat-icon-button (click)="triggerClose()">
                <mat-icon>close</mat-icon>
              </button>
            </span>
          } @else {
            <span>Chat Center</span>
          }
        </div>

        <div class="card-info">
          <div class="chat-center">
            <div class="chat-messages-container">
              @if (messages.length > 0) {
                @for (
                  message of messages;
                  track message.NoteId;
                  let i = $index
                ) {
                  <div
                    class="chat-message"
                    [ngClass]="{
                      incoming: message.CreatedByUserId !== defaultUser.id,
                      'top-message': i === 0,
                    }"
                  >
                    <div class="sender-info">
                      {{ message.CreateDate | date: 'medium' }}
                    </div>
                    <div class="chat-bubble mb-2">
                      <span [innerHTML]="message.NoteText"></span>
                    </div>
                  </div>
                }
              } @else if (messages.length <= 0 && !responseLoading) {
                <div class="no-chat-container">
                  {{
                    embedded
                      ? 'Ask any questions about income calculations here and our AI chatbot will help you'
                      : 'No messages found'
                  }}
                </div>
              }
              @if (responseLoading) {
                <div class="chat-message incoming response-loading">
                  <div class="chat-bubble mb-2">
                    <app-simple-loading />
                  </div>
                </div>
              }
            </div>
            <div class="chat-input">
              <form (submit)="submitNote()">
                <div class="input-container">
                  @for (file of files; track file; let i = $index) {
                    <div
                      class="attached-file"
                      [ngClass]="{
                        'disable-file': loadingFiles.includes(file.name),
                      }"
                    >
                      @if (loadingFiles.includes(file.name)) {
                        <mat-spinner class="attach-icon" diameter="12" />
                      } @else {
                        <button
                          type="button"
                          class="attach-icon"
                          [attr.aria-label]="'Remove attachment ' + file.name"
                          (click)="removeFile(file.name)"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                      <span>{{ file.name }}</span>
                    </div>
                  }
                  <div class="input-items" [ngClass]="{ embedded: embedded }">
                    <div class="input-editor">
                      <textarea
                        rows="1"
                        id="chatInput"
                        matInput
                        type="text"
                        placeholder="Message"
                        name="Message"
                        [(ngModel)]="message"
                        (keydown.enter)="checkSubmit($event)"
                      ></textarea>

                      <div class="input-disclaimer">
                        Shift + Enter starts a new line.
                      </div>
                    </div>

                    <span class="input-buttons">
                      @if (canUploadDoc) {
                        <span class="file-upload-container">
                          <input
                            #fileUpload
                            type="file"
                            class="file-input"
                            multiple
                            (change)="addFiles($event)"
                          />
                          <button
                            type="button"
                            mat-mini-fab
                            class="upload-btn ms-2"
                            aria-label="Attach file"
                            matTooltip="Attach file"
                            (click)="fileUpload.click()"
                          >
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </span>
                      }
                      @if (canSpeechToText) {
                        <app-speech-to-text
                          #speechToText
                          class="ms-2"
                          [speechReviewed]="true"
                          [typedText]="message"
                          [externalTriggerStop]="externalTriggerStop"
                          (text)="applySpeechToTextNote($event)"
                          (noteSpeechError)="applySpeechToTextError($event)"
                        />
                      }
                      <span
                        matTooltip="{{
                          loadingFiles.length
                            ? 'Attaching files...'
                            : 'Send message'
                        }}"
                      >
                        <button
                          class="mx-2"
                          mat-mini-fab
                          aria-label="Submit Note"
                          color="primary"
                          type="submit"
                          [disabled]="
                            !message ||
                            message === '<p></p>' ||
                            responseLoading ||
                            voiceUsed ||
                            loadingFiles.length > 0
                          "
                        >
                          <mat-icon>send</mat-icon>
                        </button>
                      </span>
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (!embedded) {
      <div class="col-md-5 col-12 card-container">
        <div class="info-card mb-4 w-100 p-0">
          <div class="card-header">Captured Data</div>

          <div class="card-info">
            @if (capturedData && !error) {
              <div class="captured-data">
                <markdown [data]="capturedData" />

                @if (responseLoading) {
                  <app-simple-loading [message]="'Processing data...'" />
                }
              </div>
            } @else if (!capturedData && responseLoading) {
              <div class="data-loading">
                <app-simple-loading [message]="'Capturing data...'" />
              </div>
            } @else if (!responseLoading && error) {
              <div class="error-message">
                <span> Oops! Something went wrong, please try again. </span>
              </div>
            } @else {
              <div class="no-response">
                <span> Captured data will show here. </span>
              </div>
            }
          </div>

          <div class="action-buttons-container">
            <button
              type="button"
              matButton
              color="warn"
              class="me-2"
              [disabled]="responseLoading"
              (click)="cancelChat()"
            >
              <mat-icon>close</mat-icon> Cancel & Exit
            </button>

            <button
              type="button"
              matButton="elevated"
              color="accent"
              [disabled]="!capturedData || responseLoading"
              (click)="saveAndExit()"
            >
              <mat-icon>save</mat-icon> Save & Exit
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
